
import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { toast } from 'react-hot-toast'
import { Loader2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import * as env from '@/env'

type EnterOtpMode = 'signup' | 'login'

interface EnterOtpProps {
	mode: EnterOtpMode
	email: string
	otpChallengeId: string
	onContinue: (isExistingUser: boolean) => void, 
	onBack: () => void, 
}

export function EnterOtp(props: EnterOtpProps) {
	const [isLoading, setIsLoading] = useState(false)
	const [otp, setOtp] = useState('')

	const isValidOtp = (otp: string): boolean => {
		return /^\d{6}$/.test(otp)
	}

	const handleContinue = async (): Promise<void> => {
		setIsLoading(true)
		try {
			const response = await fetch(`${env.restBaseUrl}/api/v1/verify-otp`, {
				method: 'POST',
				credentials: 'include', 
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ 
					email: props.email, 
					otp, 
					otpChallengeId: props.otpChallengeId, 
					isSignup: props.mode === 'signup'
				})
			})
			if (!response.ok) {
				throw new Error('Failed to verify OTP')
			}

			// note the jwt token (that is the actual result of verifying the otp) 
			// is not part of the response content. 
			// instead, the server sends it in an HttpOnly cookie. 
			// (the browser will automatically store it and send it with subsequent requests.)

			// const user = await response.json()
			// setUser(user)
			const result = await response.json()
			const userId = result.userId
			const isExistingUser = !!userId

			// if (data.location) {
			// 	props.setLocation(data.location)
			// 	props.setHasValidLocation(true)
			// }
			// if (data.introduction) {
			// 	props.setIntroduction(data.introduction)
			// }

			props.onContinue(isExistingUser)
		} catch (error) {
			toast.error('Error verifying OTP. Please try again.')
			console.error('Error verifying OTP:', error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<div className="space-y-4">
			<label className="block text-sm text-gray-700">
				We have sent you an email with a 6-digit verification code; please enter it below. 
			</label>			
			{/* {props.mode === 'signup' && (
				<label className="block text-sm font-normal text-gray-700">
					This is to make sure that no one else can sign up using your email address. 
				</label>
			)} */}
			<label className="block text-sm font-normal text-gray-700">
				If you can't find our email, check your Spam folder. 
				If still not found, please double-check your email address in the previous step, 
				and try again.
			</label>
			<Input
				type="text"
				autoComplete="one-time-code"
				placeholder="123456"
				maxLength={6}
				value={otp}
				onChange={(e) => setOtp(e.target.value)}
			/>
			<div className="flex justify-between">
				<Button
					onClick={props.onBack}
					className="bg-red-500 hover:bg-red-600 text-white flex items-center justify-center w-24"
				>
					<ChevronLeft className="mr-2 h-4 w-4" />
					Back
				</Button>
				<Button
					onClick={handleContinue}
					disabled={!isValidOtp(otp) || isLoading}
					className="bg-green-500 hover:bg-green-600 text-white flex items-center justify-center w-32"
				>
					{isLoading ? (
						<>
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
						</>
					) : (
						<>
							Continue
							<ChevronRight className="ml-2 h-4 w-4" />
						</>
					)}
				</Button>
			</div>
		</div>
	)
}
